const batchType = require('../../batchType');
const batchStatus = require('../../batchStatus');

const bat = {
  BATCH_HAS_NO_TRANSFERS: {
    message: 'Seu lote não tem transferências, registre transferências para fechá-lo',
    field: 'transfers',
    code: 'BAT_1'
  },
  BANK_ACCOUNT_NOT_FILLED_YET: {
    message:
      'Você ainda não informou os dados da conta bancária, por favor, acesse nossa aplicação web para informá-los',
    field: 'received_bank_account_id',
    code: 'BAT_2'
  },
  INVALID_BATCH_TYPE: {
    message: `O tipo do lote deve ser "${batchType.TRANSFER}" ou "${batchType.BILLET}"`,
    field: 'type',
    code: 'BAT_3'
  },
  INVALID_BATCH_NAME: {
    message: 'Nome do lote inválido',
    field: 'name',
    code: 'BAT_4'
  },
  INVALID_BATCH_UPDATE: {
    message: `O status atual do lote não permite atualização. Somente são permitidas alterações em lotes com o status ${batchStatus.DRAFT} ou ${batchStatus.FINISHED}, neste caso, apenas o campo reconciled`,
    code: 'BAT_5'
  },
  TOO_MANY_PAYMENTS: {
    message: 'O lote não pode ter mais do que {{size}} pagamentos (transferências/boletos)',
    code: 'BAT_6',
    variable: 'size'
  },
  MAX_DAILY_VALUE: {
    message: 'O valor do lote é maior que o limite diário permitido (R$ {{maxValue}})',
    field: 'value',
    variable: 'maxValue',
    code: 'BAT_7'
  },
  MAX_SCHEDULED_DAILY_VALUE: {
    message: 'Pagamentos agendados para o dia {{date}} são maiores que o valor diário permitido (R$ {{maxValue}})',
    field: 'value',
    variable: ['maxValue', 'date'],
    code: 'BAT_8'
  },
  BATCH_LOCKED: {
    message: 'Há outra operação alterando este lote neste momento e a alteração não foi aplicada.',
    field: 'batch',
    code: 'BAT_9'
  }
};

module.exports = bat;
